
import { HCOM_NEWER_FLOW_SIMILAR_TO_TV } from '../../../config/constant';
import { totalPriceCal } from '../../JS/totalPriceCal'

const calculateTotalPrice = (item,quantity,addOn) => {
    let totalPrice;
    totalPrice = item.itemPrice * quantity;
    addOn.map((iterator) => {
        totalPrice = totalPrice + iterator.price;
    })
    // this.state.upsell.map((iterator) => {
    //     totalPrice = totalPrice + iterator.itemPrice;
    // })
    console.log("totalPrice", totalPrice);
    return totalPrice;
}

const idGenerator = (arr) => {
    if(!arr){
        return;
    }

    let id = 0;
    if(arr.length === 0){
        id = 1;
    }else{
        id = arr[arr.length-1].id + 1;
    }

    return id;
}


export const addToMyOrder = (item,{quantity,addOn},setHCommerceSavedOrders,setTotalOrderPrice,closeOrderPopUp,callback, added_to_cart) => {
    let totalPrice = 0;
    console.log("quantity and add on",quantity,addOn)
    let selectedFood = item ; 
    console.log("store level 1 selectedFood",selectedFood);
    let savedOrders = localStorage.getItem("savedOrders");
    console.log("savedOrders", savedOrders)
    if (savedOrders && savedOrders !== "null") {
        savedOrders = JSON.parse(savedOrders);
    } else {
        savedOrders = []
    }
    totalPrice = calculateTotalPrice(selectedFood,quantity,addOn);
    let order;
    order = {
        id: idGenerator(savedOrders),
        item: selectedFood,
        quantity: quantity,
        totalPrice: totalPrice,
        addOns: addOn
    }
    if (savedOrders.length === 0) {
        savedOrders.push(order);
    } else {
        let isItemFound = false;
        let addOnPresent = false;
        let iteratorId = null;

        savedOrders.map((iterator) => {

            if (iterator.item.id === selectedFood.id && !addOnPresent) {
                isItemFound = true;

                if(iterator.addOns.length !== addOn.length){
                    addOnPresent = false;
                    iteratorId = null;
                }else if(iterator.addOns.length === 0 && addOn.length === 0){
                    addOnPresent = true;
                    iteratorId = iterator.id;
                }else{

                    for(let i=0; i< addOn.length; i++){
                        addOnPresent = iterator.addOns.some(el => el.id === addOn[i].id)
                        if(!addOnPresent){
                            iteratorId = null;
                            break;
                        }
                    }

                    if(addOnPresent){
                        iteratorId = iterator.id;
                    }
                }
                
            } 
            // else {
            //     savedOrders.push(order);
            // }
        })
        if (!isItemFound) {
            savedOrders.push(order);
        }else if(isItemFound && addOnPresent && iteratorId){

            savedOrders.map(iterator => {
                if(iterator.id === iteratorId){
                     // Milind: Adding same quantity for the item added instead of adding it by 1.
                    iterator.quantity = iterator.quantity + quantity //1
                    iterator.totalPrice = iterator.totalPrice + totalPrice//selectedFood.itemPrice
                    // addOn.map((iter) => {
                    //     iterator.totalPrice = iterator.totalPrice + iter.price;
                    // })
                    // iterator.addOns.push(...addOn);
                }

            })
        }else if(isItemFound && !addOnPresent && !iteratorId){
            savedOrders.push(order);
        }
    }

    setHCommerceSavedOrders(savedOrders);
    savedOrders = JSON.stringify(savedOrders);
    localStorage.setItem("savedOrders", savedOrders);
    totalPrice = totalPriceCal();
    setTotalOrderPrice(totalPrice);
    //this.props.popupOpenClose(true, "saved to cart.");
    //this.props.changePage("myOrder");
    closeOrderPopUp(true, `${item.itemName} ${added_to_cart}`);
    callback();
}


export const removeItemHandler = (item,{totalPrice,setHCommerceSavedOrders,setTotalOrderPrice},callback) => {
    let totPrice;
    let savedOrders = localStorage.getItem("savedOrders");
    if (savedOrders && savedOrders !== "null") {
        savedOrders = JSON.parse(savedOrders);
    } else {
        savedOrders = []
    }
   
    savedOrders.map((iterator, index) => {
        if (iterator.id === item.id) {
           
            savedOrders.splice(index, 1);
            totPrice = totalPrice - iterator.totalPrice
           console.log('totalPrice******', totPrice, totalPrice, iterator.totalPrice)
        }
    })

    callback(savedOrders, totPrice);
    setHCommerceSavedOrders(savedOrders);
    setTotalOrderPrice(totPrice);
    savedOrders = JSON.stringify(savedOrders);
    localStorage.setItem("savedOrders", savedOrders);
}

export const formatPriceForDisplay = (value, precision) => {
    precision = Number.isFinite(Number(precision)) && precision !== "" ? Math.floor(Number(precision)) : 2;

    const [integerPart, decimalPart = ""] = value.toString().split(".");

    const truncatedDecimal = decimalPart.slice(0, precision).padEnd(precision, "0");

    return `${integerPart}.${truncatedDecimal}`;
};

export const getQuantityCountToBeDisplayed = (savedOrders) => {
        if(!HCOM_NEWER_FLOW_SIMILAR_TO_TV) return savedOrders.length; 
        
        return savedOrders.reduce((acc, curr)=>{return acc + curr.quantity}, 0);
    }


export const removeUpsellItemUncheckingAtDetailScreen = (item, {totalPrice, setHCommerceSavedOrders,setTotalOrderPrice, closeOrderPopUp}) =>{
    
    let updatedTotalPrice;
    let savedOrders = localStorage.getItem("savedOrders");

    if (savedOrders && savedOrders !== "null") {
        savedOrders = JSON.parse(savedOrders);
    } else {
        savedOrders = []
    }

    console.log(savedOrders, "savedOrders", item)
    savedOrders.forEach((iterator, index) => {
        if (iterator.item.id === item.id) {
           console.log(iterator, "iterator")
           
            if(iterator.quantity == 1){
                savedOrders.splice(index, 1)
            } else {
                const updatedElement= {...iterator};
                updatedElement.quantity -= 1
                updatedElement.totalPrice -= updatedElement.item.itemPrice;
                savedOrders[index] = updatedElement;
            }
            updatedTotalPrice = totalPrice - iterator.item.itemPrice;

        }
    })

    console.log("updatedTotalPrice", updatedTotalPrice, totalPrice)

    setHCommerceSavedOrders(savedOrders);
    setTotalOrderPrice(updatedTotalPrice);
    closeOrderPopUp(true, `${item.itemName} ${'removed from cart'}`);
    savedOrders = JSON.stringify(savedOrders);
    localStorage.setItem("savedOrders", savedOrders);
}